Vue.component('house-filter', {
    props: {
        data: {
            type: Array,
            default: []
        },
        categories: {
            type: Array,
            default: [],
        },
        currency: String
    },

    data: function(){
        return{
            priceRangeFilter: {
                max: 0,
                min: 0
            },
            filters: {
                text: '',
                filterText: '',
                petAllowed: false,
                askSell: false,
                sellImmediately: false,

                price: {
                    max: 0,
                    min: 0
                },
                properties: {},
            }
        }
    },
    created: function(){
        this.$emit("input", this.data);
    },
    methods: {
        setPriceRangeFilterMaxMinVal: function(){
            var prices = this.data.map(function (house) {
                return parseInt(house.dailyPrice);
            });

            var max = Math.max.apply(Math, prices);
            var min =  Math.min.apply(Math, prices);
            max =  parseInt(max);
            min = parseInt(min);

            if (max && min) {
                this.priceRangeFilter.max = max;
                this.priceRangeFilter.min = min;
                this.filters.price.max = max;
                this.filters.price.min = min;
            }
        },

        filterByPrice: function(houses){
            var vm = this;
            var price =  this.filters.price;
            return houses.filter(function (house) {
                house.dailyPrice = Math.floor(house.dailyPrice);
                return house.dailyPrice >= price.min && house.dailyPrice <= price.max;
            });
        },
        applyFilter: function(){
            var houses = this.data.slice();

            houses = this.filterByText(houses);
            houses = this.filterByPrice(houses);
            houses = this.filterByStatus(houses);
            houses = this.filterByProperties(houses);

            this.$emit("input", houses);
        },
        filterByProperties: function(houses){
            var vm = this;
            var properties = this.filters.properties;

            var villaCategoryId = 2;
            var propertiesCategoryId = 4;
            var conceptCategoryId = 8;

            for(var categoryId in properties){

                if (properties[categoryId].length == 0){
                    continue;
                }

                houses = houses.filter(function (house) {
                    var props = house.properties.filter(function (property) {
                        return properties[categoryId].includes(property);
                    });

                    if(categoryId == conceptCategoryId || categoryId == propertiesCategoryId){
                        return props.length == properties[categoryId].length;
                    }
                    return props.length > 0;
                    //return props.length === vm.filters.length;
                });
            }
            return houses;
        },
        filterByStatus: function(houses){

            var vm = this;

            return houses.filter(function (house) {
                var match = true;

                if (match && vm.filters.sellImmediately){
                    match = match && !house.asksell;
                }
                if (match && vm.filters.askSell){
                    match = match && house.asksell;
                }
                if (match && vm.filters.petAllowed){
                    match = match && house.petAllowed;
                }
                return match;
            });
        },
        filterByText: function(houses){
            var vm = this;
            var text = this.filters.text.toLowerCase();
            return houses.filter(function(house){
                return house.houseName.toLowerCase().indexOf(text) >=0;
            });
        },


        addOrRemoveFilterProperty: function (category, property) {
            this.$parent.addOrRemoveFilterProperty(category, property);
        },
    },
    computed: {
        filterPricePlaceholder: function () {
            return this.filters.price.min + ' ' + this.currency + ' - ' + this.filters.price.max + ' ' + this.currency;
        }
    },
    watch: {
        data: {
            handler: function () {
                this.setPriceRangeFilterMaxMinVal();
            },
            deep: true
        },
        filters: {
            handler: function(){
                this.applyFilter();
            },
            deep: true
        }
    }
});